import Icon from './Icon.jsx';

/**
 * EmptyState — used when a data fetch resolves successfully but returns
 * nothing relevant to the current filter. The CTA is optional.
 */
export default function EmptyState({ title, message, action, icon = 'search' }) {
  return (
    <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
      <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-bg-card2 text-ink-tertiary ring-1 ring-stroke">
        <Icon name={icon} size={26} />
      </div>
      <h3 className="text-lg font-semibold text-ink-primary">{title}</h3>
      {message ? (
        <p className="mt-2 max-w-xs text-sm leading-relaxed text-ink-secondary">{message}</p>
      ) : null}
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}
